import {
  EnumDropdown,
  EnumDropdownCreateForm,
  PureEnumDropdown,
  PureEnumDropdownProps,
} from './EnumDropdown';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants';
import { translate } from '../../helpers';
import { PureEnumMultiDropdownField, PureEnumMultiDropdownFieldProps } from './EnumMultiDropdown';

const fieldName = ISSUE_ATTRIBUTE_NAMES.SCHEDULE; // 'scheduleImpact'

export const ScheduleImpactFormikField = () => (
  <EnumDropdown
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={fieldName}
    clearable
  />
);

export const ScheduleImpactInCreateForm = () => {
  const fieldName = ISSUE_ATTRIBUTE_NAMES.SCHEDULE;
  return (
    <EnumDropdownCreateForm
      fieldName={fieldName}
      label={translate(`new.${fieldName}`)}
      placeholder={translate(`new.placeholder.${fieldName}`)}
      id={fieldName}
      clearable
    />
  );
};

export const ScheduleImpactField = ({
  value,
  onChange,
  disabled,
}: Pick<PureEnumDropdownProps, 'value' | 'onChange' | 'disabled'>) => (
  <PureEnumDropdown
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={`inline-${fieldName}`}
    value={value}
    onChange={onChange}
    clearable
    disabled={disabled}
  />
);

export const ScheduleImpactMultiSelectField = ({
  value,
  onChange,
  disabled = false,
  'data-testid': dataTestId,
}: Pick<PureEnumMultiDropdownFieldProps, 'value' | 'onChange' | 'disabled' | 'data-testid'>) => (
  <PureEnumMultiDropdownField
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={`inline-${fieldName}`}
    value={value}
    onChange={onChange}
    disabled={disabled}
    withUnspecified
    clearable
    data-testid={dataTestId}
  />
);
